export default {
   globalNavBackgroundColor: '#fff',
   globalNavBorderColor: '#e5e5e5',
   globalNavDividerColor: '#ddd',
   globalNavIsHidden: false,
   globalNavLogoFieldName: 'logoDefault',
   globalNavSize: '60px[a-b] 78px[c-d] 84px[e-f]',
   globalNavTextColor: '#333',
   // Note: These settings colours constants are highly subject to change
   // Use with care see PR #328
   protoSettingsChromeBackgroundColor: '#1a1818',
   protoSettingsViewportBackgroundColor: 'rgb(247, 247, 245)',
   protoSettingsHighlightBackgroundColor: '#342e39',
   protoSettingsHighlightForegroundColor: '#99cbff',
   viewportContentMaxWidth: '1700px',
   viewportMarginBottom: '0px',
   viewportMarginLeft: '0px',
   viewportMarginRight: '0px',
   viewportMarginTop: '60px[a-b] 78px[c-d] 84px[e-f]',
   viewportPaddingBottom: '0px[a] 2vw[b] 2vw[c] 3vh[d] 3vh[e] 2vw[f]',
   viewportPaddingLeft: '18px[a] 9vw[b] 6vw[c] 4vw[d] 100px[e] 200px[f]',
   viewportPaddingRight: '18px[a] 9vw[b] 6vw[c] 4vw[d] 100px[e] 200px[f]',
   viewportPaddingTop: '30px[a] 7vw[b] 5vw[c] 6vh[d] 8vh[e] 3vw[f]'
}
